import "./App.css";
import Navbar from "./Navbar";
import Layout from "./components/Layout/Layout";

const App = () => {
  return (
    <div className="App">
      <Navbar />
      <Layout />
    </div>
  );
};

export default App;
